var E = {
  init: function init(n) {
    void 0 === n && void 0 !== E.zg || (E.zg = !!n), E.i || (E.i = !0);
  },
  destroy: function destroy() {
    E.i = !1, E.zg = void 0, E.vd = void 0;
  },
  setLogger: function setLogger(n) {
    "function" == typeof n ? (E.init(), E.vd = n) : E.info("Ignoring setLogger call since logger is not a function");
  },
  toggleLogging: function toggleLogging() {
    E.init(), E.zg ? (console.log("Disabling Braze logging"), E.zg = !1) : (console.log("Enabled Braze logging"), E.zg = !0);
  },
  info: function info(n) {
    if (E.zg) {
      var o = "Braze: " + n;
      null != E.vd ? E.vd(o) : console.log(o);
    }
  },
  warn: function warn(n) {
    if (E.zg) {
      var o = "Braze SDK Warning: " + n + " (v6.2.0)";
      null != E.vd ? E.vd(o) : console.warn(o);
    }
  },
  error: function error(n) {
    if (E.zg) {
      var o = "Braze SDK Error: " + n + " (v6.2.0)";
      null != E.vd ? E.vd(o) : console.error(o);
    }
  }
};
export default E;